var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import DeviceBatteryStatus from "../../components/ui/DeviceBatteryStatus/DeviceBatteryStatus";
import DateTime from "../../components/ui/DateTime/DateTime";
import Signals from "../../../signals/Signals";
import UpdateDeviceSettingsOverlay from "./UpdateDeviceSettingsOverlay";
import GetDeviceSettingsCommand from "../../../commands/devices/GetDeviceSettingsCommand";
import { ApplicationContext } from "../../../ApplicationContext";
import DetachDeviceCommand from "../../../commands/devices/DetachDeviceCommand";
import ListOrganisationDevicesCommand from "../../../commands/devices/ListOrganisationDevicesCommand";
import classNames from "classnames";
var DeviceRow = /** @class */ (function (_super) {
    __extends(DeviceRow, _super);
    /**
     *
     */
    function DeviceRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { device: _this.props.device };
        _this.loadDeviceSettings = _this.loadDeviceSettings.bind(_this);
        _this.detachDevice = _this.detachDevice.bind(_this);
        _this.reloadDevices = _this.reloadDevices.bind(_this);
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    DeviceRow.prototype.render = function () {
        var device = this.props.device;
        var classes = classNames({
            'device-row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        return React.createElement("div", { style: { display: "contents" }, className: classes },
            React.createElement("div", { className: "text-nowrap text-left align-middle" }, device.name),
            React.createElement("div", { className: "text-nowrap text-left align-middle" }, device.link_device_id_serial),
            React.createElement("div", { className: "text-nowrap text-left align-middle" }, device.model),
            React.createElement("div", { className: "text-nowrap text-left align-middle" }, device.fourBarBatterySample ? React.createElement(DeviceBatteryStatus, { device: device }) : '-'),
            React.createElement("div", { className: "text-nowrap text-left align-middle" },
                device.hasLocation ?
                    React.createElement("a", { href: device.googleMapsUrl, target: "_blank" },
                        React.createElement("div", { className: "d-flex justify-content-between w-100" },
                            device.place,
                            React.createElement("i", { className: "ml-4 fe fe-external-link" }))) : '-',
                device.hasLocation &&
                    React.createElement("span", { className: "small text-muted d-flex" },
                        React.createElement(DateTime, { date: device.locationDateTime }))),
            React.createElement("div", { className: "text-nowrap" }, device.attachedToAsset ?
                React.createElement(React.Fragment, null,
                    React.createElement("button", { className: 'btn btn-sm w-50 btn-outline-primary ml-0', onClick: this.loadDeviceSettings },
                        React.createElement("i", { className: "fe fe-edit-2" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "page.devices.configure" })),
                    React.createElement("button", { className: 'btn btn-sm w-50 btn-outline-warning', onClick: this.detachDevice },
                        React.createElement("i", { className: "fe fe-x" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "page.devices.detach" }))) :
                React.createElement("button", { className: 'btn btn-sm w-100 btn-outline-primary ml-0', onClick: this.loadDeviceSettings },
                    React.createElement("i", { className: "fe fe-edit-2" }),
                    " ",
                    React.createElement(FormattedMessage, { id: "page.devices.configure" }))));
    };
    DeviceRow.prototype.loadDeviceSettings = function () {
        var session = this.context.session;
        var device = this.state.device;
        var intl = this.props.intl;
        var command = new GetDeviceSettingsCommand();
        command.execute(device.link_device_id, session.user.organisation.id)
            .then(function (r) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            Signals.ShowOverlay.dispatch(React.createElement(UpdateDeviceSettingsOverlay, { deviceModel: device, initialOperatingHoursEnabled: (_d = (_b = (_a = r.operatingHoursEnabled.desired) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (_c = r.operatingHoursEnabled.reported) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : true, initialGpsSettingValue: (_h = (_f = (_e = r.gps.desired) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : (_g = r.gps.reported) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : 'Medium', initialWakeupIntervalSecondsValue: (_m = (_k = (_j = r.wakeupIntervalSeconds.desired) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : (_l = r.wakeupIntervalSeconds.reported) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : 3600 * 12 }));
        }).catch(function (r) {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "device.settings.error" }, device), 'danger', true);
        });
    };
    DeviceRow.prototype.detachDevice = function () {
        var _this = this;
        var _a = this.context, session = _a.session, deviceCollection = _a.deviceCollection;
        var intl = this.props.intl;
        var device = this.state.device;
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.devices.detach.confirm.title' }), intl.formatMessage({ id: 'page.devices.detach.confirm.body' }, device), intl.formatMessage({ id: 'page.devices.detach.confirm.yes' }), intl.formatMessage({ id: 'page.devices.detach.confirm.no' }), function () {
            var command = new DetachDeviceCommand();
            command.execute(session.user.organisation.id, device, intl).then(_this.reloadDevices);
        });
    };
    DeviceRow.prototype.reloadDevices = function () {
        var deviceCollection = this.context.deviceCollection;
        var command = new ListOrganisationDevicesCommand();
        command.execute(deviceCollection);
    };
    return DeviceRow;
}(React.Component));
DeviceRow.contextType = ApplicationContext;
export default injectIntl(DeviceRow);
